import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function cardmsgA({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div className={`${css.cardmsgA} cardmsgA1 GtmModuleData-section`} data-section-id={css.cardmsgA} data-section-title={t('extra_battery_port')}>
            <div className="card-icon-msg-box card-icon-msg-box2">
                <div className="msg-title1">
                    <div className="title-icon">
                        <Image src="/icons/mobileH5/TheExtraBatteryPortIcon.svg" className="fullImgs" layout="fill" alt={t('extra_battery_port')} />
                    </div>
                    {t('extra_battery_port')}
                </div>
                <div className="msg-title2">
                    {t.rich('extra_battery_port_sub_title', {
                        line1: (child: string) => <span>{child}</span>,
                        line2: (child: string) => <span className="card-color-2">{child}</span>,
                        line3: (child: string) => <span>{child}</span>,
                    })}
                </div>
                <div className="msg-desc">{t('extra_battery_port_desc')}</div>
            </div>
        </div>
    );
}
